<template>
  <v-card class="dashboard-item limit-dimensions" @click="goTo()">
    <v-img
      v-if="image"
      :src="image"
      aspect-ratio="2.57"
      class="flex-none"
    >
      <div class="image-overlay"></div>
      <v-chip
        label
        small
        :color="activityReservationColorsByStatusDark[isUpcoming ? 'UPCOMING' : status].background"
        :text-color="activityReservationColorsByStatusDark[isUpcoming ? 'UPCOMING' : status].text"
        class="float-left status-chip"
      >
        {{ statusText }}
      </v-chip>
      <v-layout v-if="room" class="float-right white--text">
        <v-icon small class="material-symbols-rounded" color="white">pin_drop</v-icon>
        <div class="H8 room_text">{{ room }}</div>
      </v-layout>
      <v-layout v-else-if="attendees" class="float-right white--text">
        <v-icon small class="material-symbols-rounded" color="white">group</v-icon>
        <div class="attendees_badge">{{ attendees }}</div>
      </v-layout>
    </v-img>
    <v-card-text class="d-flex align-start justify-center flex-column">
      <div class="text-color__dark H4 one-line">{{ title }}</div>
      <v-layout justify-start align-center class="text-color__dark app-body-2">
        <v-icon small color="primary darken-1" class="material-symbols-rounded mr-1">calendar_month</v-icon>
        <div class="mr-3">{{ date }}</div>
        <v-icon small color="primary darken-1" class="material-symbols-rounded mr-1">chronic</v-icon>
        <div>{{ time }}</div>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
  
<script>
import router from '@/router'
import routeNames from '@/router/routes'
import { displayFormatDate } from '@/lib/helpers/DateUtils'
import { getTimeFormat } from '@/lib/helpers/HoursFormatter'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { reservationTypes, activityReservationColorsByStatusDark, activityReservationStatus } from '@/config'
import moment from 'moment'
  
export default {
  props: {
    reservation: Object,
  },
  data () {
    return {
      activityReservationColorsByStatusDark,
    }
  },
  computed: {
    image () {
      return this.reservation.webappPage.coverImageUrl
    },
    title () {
      return getTextValue(this.reservation.webappPage.pageSpecific.title)
    },
    date () {
      const date = this.reservation.reservation.acceptedDate || this.reservation.reservation.requestedDate
      return displayFormatDate(date, 'sm', true)
    },
    time () {
      const time = this.reservation.reservation.acceptedTime || this.reservation.reservation.requestedTime
      return moment.utc(time).format(getTimeFormat())
    },
    attendees () {
      const numeralAttendees = this.reservation.numeralAttendees.reduce((total, attendee) => {
        return total + attendee.quantity
      }, 0)
      const nominalAttendees = this.reservation.nominalAttendees.length
      return numeralAttendees || nominalAttendees
    },
    room () {
      const room = this.isRoomService && this.reservation.room ? this.reservation.room.name : null
      return room
    },
    status () {
      return this.reservation.reservation.status
    },
    isRoomService () {
      return this.reservation.reservation.type === reservationTypes.ROOM_SERVICE
    },
    isUpcoming () {
      const lessThan24H = moment.duration(moment(this.reservation.reservation.acceptedDate || this.reservation.reservation.requestedDate).diff(moment())).asHours() <= 24
      return lessThan24H && this.reservation.reservation.status === activityReservationStatus.ACCEPTED && !this.isRoomService
    },
    statusText () {
      if (this.isUpcoming) {
        return this.$t('reservations.short_status.UPCOMING')
      }
      if (this.isRoomService && this.$te('reservations.order_short_status.' + this.status)) {
        return this.$t('reservations.order_short_status.' + this.status)
      } else if (this.$te('reservations.short_status.' + this.status)) {
        return this.$t('reservations.short_status.' + this.status)
      } else if (this.isRoomService && this.$te('reservations.order_status.' + this.status)) {
        return this.$t('reservations.order_status.' + this.status)
      } else {
        return this.$t('reservations.status.' + this.status)
      }
    },
  },
  methods: {
    goTo () {
      router.push({ name: routeNames.activity_reservations.name, query: { reservationId: this.reservation.reservation.id }})
    },
  },
}
</script>

<style lang="scss" scoped>
.room_text {
  margin-left: 3px;
}

.attendees_badge {
  border-radius: 50px;
  padding: 3px;
  margin-left: 3px;
  width: 15px;
  height: 15px;
  background-color: var(--v-primary-lighten1);
  color: #FFF;
  text-align: center;
  font-family: 'Mukta Mahee';
  font-size: 10.435px;
  font-style: normal;
  font-weight: 500;
  line-height: 10.435px;
  letter-spacing: 0.261px;
}
.dashboard-item {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--v-custom-grey-lighten1);
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10) !important;
  height: 100%;
  .one-line {
    max-width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description {
    margin-top: 5px;
  }
  .v-image {
    position: relative;
  }
  .image-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 10px 10px 0px 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.60) 8.09%, rgba(0, 0, 0, 0.00) 38.73%, rgba(0, 0, 0, 0.00) 59.79%, rgba(0, 0, 0, 0.60) 100%);

  }
  .icon-container {
    background-color: rgba(var(--v-primary-lighten1-rgb), 0.1);
  }
  .v-card__text {
    padding: 20px;
    vertical-align: middle;
  }
}
.v-image {
  .float-right {
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .float-left {
    position: absolute;
    top: 10px;
    left: 10px;
  }
}
.dashboard-item.limit-dimensions {
  width: 210px;
  height: 173px;
  .image-overlay, .v-image {
    height: 110px;
  }
  .v-card__text {
    padding-top: 6px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 6px;
  }
}
</style>
  